/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IDeletePopoverScope extends angular.IScope {
        model: models.DeletePopoverModel;
        templateUrl: string;
        deleteCallback: (index?: number) => void;
        index: string;
        name: string;
    }

    export class DeletePopover implements IDirective {
        public controller = ['$scope', DeletePopoverController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/calculate/deletePopover.html';
        public restrict: string = "E";

        public scope: any = {
            thisObject: "=",
            deleteCallback: "=",
            index: "@",
            name: "@"
        };

        public link(scope: IDeletePopoverScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: DeletePopoverController): void {
            scope.templateUrl = "./app/views/directives/calculate/deletePopoverContent.html";
        }
    }

    export class DeletePopoverController implements IController {

        constructor(private $scope: IDeletePopoverScope) {
            var index = parseInt(this.$scope.index);
            this.$scope.model = new models.DeletePopoverModel(this.$scope.deleteCallback, this.$scope.name, index);
        }
    }
}

warsApp.registerDirective('DeletePopover', []);